const Switcher = (props) => <label className={`font-weight-normal preact-switch switcher${props.disable ? ' disable' : ''}`}>
  <div className={'control-switcher' + (props.on ? ' on' : '')}>
    <a className={'toggle'} onClick={(e) => { e.preventDefault(); e.stopPropagation(); props.onChange() }} href={'#'}><i className={'icon-handler'} /></a>
    <a className={'ui-on'} onClick={(e) => { e.preventDefault(); e.stopPropagation(); props.onChange() }} href={'#'}><i className={'icon-check-slim'} /></a>
    <a className={'ui-off'} onClick={(e) => { e.preventDefault(); e.stopPropagation(); props.onChange() }} href={'#'}><i className={'icon-cross-slim'} /></a>
  </div>
  {props.label}
</label>

export default Switcher
